/* eslint-disable no-restricted-syntax */
/* eslint-disable no-use-before-define */
/* eslint-disable react/prop-types */
import React, { useState } from "react";
import styled from "styled-components";

import { callApiPost } from 'Core/services/api';

import { getExpiredDate, getStateTitle, isExpired, isNew, isActive, isResumable } from "./fixtures/subscription";
import { SubscriptionInfo } from "./SubscriptionInfo";
import { ConfirmCancelModal, ConfirmResumeModal } from "./ModalConfirm";

const modalTypes = { resume: "resume", cancel: "cancel" };

export const Subscription = ({ status, startedAt, price, loadUserProfile }) => {
  const [openedModal, setOpenedModal] = useState("");

  const toggleSubscription = async flag => callApiPost("/subscription/toggle", { is_active: flag })
    .then(() => loadUserProfile())
    .catch(() => alert("Произошла ошибка"));

  const handleConfirm = (flag) => {
    toggleSubscription(flag).finally(() => setOpenedModal(""));
  };

  return (
    <Content>
      <Items>
        <Item>
          <span>Состояние:</span>
          <span>{getStateTitle(startedAt, status)}</span>
        </Item>

        {!isNew(status) && !isExpired(startedAt) && (
          <Item>
            <span>Действует до:</span>
            <span>{getExpiredDate(startedAt)}</span>
          </Item>
        )}
      </Items>

      {isNew(status) && (
        <div className="extend_consultation_button">
          <a
            href="/payment/robokassa/subscriptions"
          >
            {`Подписаться за ${price} руб`}
          </a>
        </div>
      )}

      {!isNew(status) && isExpired(startedAt) && (
        <div className="extend_consultation_button">
          <a
            href="/payment/robokassa/subscriptions"
          >
            {`Продлить подписку за ${price} руб`}
          </a>
        </div>
      )}

      {isActive(startedAt, status) && (
        <div className="extend_consultation_button cancel" onClick={() => setOpenedModal(modalTypes.cancel)}>
          <span>Остановить подписку</span>
        </div>
      )}

      {isResumable(startedAt, status) && (
        <div className="extend_consultation_button" onClick={() => setOpenedModal(modalTypes.resume)}>
          <span>Возобновить подписку</span>
        </div>
      )}

      {openedModal === modalTypes.cancel && (
        <ConfirmCancelModal
          closeModal={() => setOpenedModal("")}
          handleConfirm={() => handleConfirm(false)}
        />
      )}

      {openedModal === modalTypes.resume && (
        <ConfirmResumeModal
          closeModal={() => setOpenedModal("")}
          handleConfirm={() => handleConfirm(true)}
        />
      )}

      <SubscriptionInfo />
    </Content>
  );
};

const Items = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 16px;
`;

const Item = styled.div`
  margin-top: 8px;
  width: 250px;
  display: flex;
  justify-content: space-between;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 16px;

  .extend_consultation_button {
    margin-top: 16px;
    padding: 0 8px;
    width: max-content;

    a, span {
      color: #fff;

      &:hover {
        color: #fff;
      }
    }
    &:hover {
      background: #3182ce;
    }
  }

  .extend_consultation_button.cancel {
    background: #b22222;
    color: #fff;
    &:hover {
      opacity: .6;
    }
  }
`;
